import { createPortal } from 'react-dom';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import { ResetPinMessageModalProps } from 'components/Pin/ResetPinMessageModal';
import { WebDiv } from 'components/WebDiv';

export const TvResetPinMessageModal = ({
  isOpen,
  type = 'success',
  title,
  message,
  onClose,
}: ResetPinMessageModalProps): React.ReactNode => {
  if (!isOpen) return null;

  const modalTitle = title ?? (type === 'error' ? 'Ops!' : 'PIN redefinido');

  const modalMessage =
    message ??
    (type === 'error'
      ? 'Não foi possível redefinir o PIN. Tente novamente mais tarde.'
      : 'Um novo PIN foi gerado e enviado para seu e-mail.');

  return createPortal(
    <WebDiv className="fullscreen-overlay navigation-container navigation-priority">
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>{modalTitle}</Text>

          <Text style={styles.text}>{modalMessage}</Text>

          <Pressable accessibilityRole="button" style={styles.closeBtn} onPress={onClose}>
            <Text style={styles.closeBtnText}>Fechar</Text>
          </Pressable>
        </View>
      </View>
    </WebDiv>,
    document.getElementById('root')!
  );
};

const styles = StyleSheet.create({
  overlay: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.85)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: calcSizeForDevice(540),
    padding: calcSizeForDevice(40),
    backgroundColor: '#050923',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#182DB3',
  },
  title: {
    fontSize: calcSizeForDevice(32),
    fontWeight: '700',
    color: '#7A8CFF',
    textAlign: 'center',
    marginBottom: 24,
  },
  text: {
    color: '#FFF',
    fontSize: calcSizeForDevice(20),
    textAlign: 'center',
  },
  closeBtn: {
    width: '100%',
    height: calcSizeForDevice(54),
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: calcSizeForDevice(32),
  },
  closeBtnText: {
    color: '#FFF',
    fontSize: calcSizeForDevice(18),
  },
});
